import { render, staticRenderFns } from "./RemoteCommands.vue?vue&type=template&id=7888eff1&scoped=true&"
import script from "./RemoteCommands.vue?vue&type=script&lang=js&"
export * from "./RemoteCommands.vue?vue&type=script&lang=js&"
import style0 from "./RemoteCommands.vue?vue&type=style&index=0&id=7888eff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888eff1",
  null
  
)

export default component.exports